export const buttonContainer = {
  paddingTop: 50,
}

export const descriptionContainer = {
  paddingTop: 20,
}
